export enum AcceptInboundShareErrorEnum {
  SHARED_ENTITY_ALREADY_EXISTS = "SHARED_ENTITY_ALREADY_EXISTS",
  ADD_ARCHIVED_ENTITY_FORBIDDEN = "ADD_ARCHIVED_ENTITY_FORBIDDEN",
  INVALID_PRODUCT_MATERIAL = "INVALID_PRODUCT_MATERIAL",
}
